import { map } from "rxjs/operators";
import { Injectable, inject } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class EmailEditorRepository {
  private http = inject(HttpClient);

  public send(
    target: string,
    idArray: number[],
    payload: { [key: string]: string },
  ): Observable<object> {
    let params = new HttpParams();
    idArray.forEach((id) => {
      params = params.append(target + "s[]", id.toString());
    });

    return this.http
      .post(`${environment.apiUrl}/message/${target}?${params}`, {
        subject: payload.subject,
        message: payload.message,
        attachment: payload.attachment,
      })
      .pipe(map((response) => response));
  }
}
